import { render, staticRenderFns } from "./SearchKnowledge.vue?vue&type=template&id=69f4d602&scoped=true"
import script from "./SearchKnowledge.vue?vue&type=script&lang=js"
export * from "./SearchKnowledge.vue?vue&type=script&lang=js"
import style0 from "./SearchKnowledge.vue?vue&type=style&index=0&id=69f4d602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f4d602",
  null
  
)

export default component.exports